import { IApplicationState } from '../../types/redux';

export const selectActiveOfferId = (state: IApplicationState) => {
  return state.listingModal.activeOfferId;
};
